<template>
  <div>
    <!-- heading starts -->
    <div class="text-center my-3 mt-5">
      <v-banner color="green accent-3" rounded class="Info-banner mx-1">
        <p class="text-h6 font-weight-bold">
          <v-icon large color="yellow lighten-2">mdi-trophy-award</v-icon>
          NBA Top Plays
        </p>

        <p class="body-1 font-weight-medium white--text">
          Create custom list of top players by your preference and save them for
          later.
        </p>
      </v-banner>
    </div>

    <!-- heading ends -->

    <v-row no-gutters class="mx-1">
      <!-- //*optimizer table -->
      <v-col cols="12" md="7" sm="12">
        <!-- //? slate list -->
        <div class="mt-3">
          <v-sheet elevation="2" rounded>
            <!-- //* controllers -->
            <v-row class="slate-selector" justify="center">
              <!-- Selector starts -->
              <v-col cols="6" md="2" sm="4" class="caption text-center">
                <strong>Slate Time NBA:</strong>
              </v-col>
              <v-col cols="6" md="3" sm="4" class="ml-n4">
                <v-select
                  light
                  :items="Slates"
                  item-text="OperatorName"
                  item-value="SlateID"
                  v-model="slateId"
                  solo
                  dense
                  @change="fetchPlayers"
                >
                  <template v-slot:item="{ item }">
                    <small class="caption">
                      {{ item.OperatorName }}&nbsp;
                      {{ item.OperatorStartTime | timeFormat }}
                      ({{ item.NumberOfGames }}games)
                    </small>
                  </template>
                </v-select>
              </v-col>
              <!-- Selector ends -->

              <!-- Radio buttons -->
              <v-col
                cols="8"
                md="5"
                sm="5"
                class="ml-md-6 mt-md-n4 mt-n2"
                align="center"
              >
                <v-radio-group v-model="radio" row>
                  <v-radio
                    label="Classic"
                    value="classic"
                    @change="onlyClassic()"
                  ></v-radio>
                  <v-radio
                    label="Single Game"
                    value="others"
                    @change="otherThanClassic()"
                  ></v-radio>
                </v-radio-group>
              </v-col>
              <!-- Radio buttons ends -->
            </v-row>

            <v-divider class="pb-5 mt-n6"></v-divider>
            <v-row
              class="filter-button-group mt-n8"
              justify="start"
              align="center"
            >
              <!--//* reset players -->
              <v-col
                cols="4"
                md="3"
                sm="1"
                class="ml-md-7 ml-md-0 mr-md-0 mr-sm-6 text-center"
              >
                <v-btn
                  class="btn-help-video mt-md-2 ml-sm-n3 ml-3 white--text"
                  small
                  color="#E53935"
                  @click="resetPlayer"
                >
                  Reset
                </v-btn>
              </v-col>
              <!--//* reset players ends-->
              <!-- <p>{{ this.selectionD }}</p> -->

              <!-- filter starts -->
              <v-col
                cols="11"
                class="mx-auto"
                md="8"
                sm="6"
                v-if="operator == 'DraftKings' && operatorGameType == 'Classic'"
              >
                <v-chip-group
                  v-model="selectionD"
                  active-class="light-green darken-3 white--text"
                  class="chip-selector"
                  center-active
                  @change="getFilterByPosition(selectionD)"
                  mandatory
                >
                  <v-chip
                    v-for="selectionD in positionD"
                    :key="selectionD"
                    :value="selectionD"
                  >
                    {{ selectionD }}
                  </v-chip>
                </v-chip-group>
              </v-col>

              <v-col
                cols="11"
                class="mx-auto mx-md-0 mx-sm-0"
                md="6"
                sm="6"
                v-if="operator == 'DraftKings' && operatorGameType == 'Single'"
              >
                <v-chip-group
                  v-model="selectionDS"
                  active-class="light-green darken-3 white--text"
                  class="ml-10 chip-selector"
                  center-active
                  @change="getFilterBySingle(selectionDS)"
                  mandatory
                >
                  <v-chip
                    v-for="selectionDS in positionDS"
                    :key="selectionDS"
                    :value="selectionDS"
                  >
                    {{ selectionDS }}
                  </v-chip>
                </v-chip-group>
              </v-col>

              <!-- //? Fandeul -->
              <v-col
                cols="11"
                class="mx-auto"
                md="8"
                sm="6"
                v-if="operator == 'FanDuel' && operatorGameType == 'Classic'"
              >
                <v-chip-group
                  v-model="selectionF"
                  active-class="light-green darken-3 white--text"
                  class="ml-4 chip-selector"
                  center-active
                  @change="getFilterByPosition(selectionF)"
                  mandatory
                >
                  <v-chip
                    v-for="selectionF in positionF"
                    :key="selectionF"
                    :value="selectionF"
                  >
                    {{ selectionF }}
                  </v-chip>
                  <!-- <v-chip></v-chip> -->
                </v-chip-group>
              </v-col>

              <v-col
                cols="11"
                class="mx-auto"
                md="6"
                sm="6"
                v-if="operator == 'FanDuel' && operatorGameType == 'Single'"
              >
                <v-chip-group
                  v-model="selectionFS"
                  active-class="green accent-3 text--accent-4"
                  class="ml-4 chip-selector"
                  center-active
                  @change="getFilterByPositionInFanduel(selectionFS)"
                  mandatory
                >
                  <v-chip
                    v-for="selectionFS in positionFS"
                    :key="selectionFS"
                    :value="selectionFS"
                  >
                    {{ selectionFS }}
                  </v-chip>
                  <!-- <v-chip></v-chip> -->
                </v-chip-group>
              </v-col>
              <!-- filter ends -->
            </v-row>
            <!-- //* controllers ends..-->
          </v-sheet>
        </div>
        <!-- //? slate list -->

        <!--//? Position optimizer table -->
        <v-row no-gutters>
          <v-col cols="12" md="12" sm="12">
            <v-skeleton-loader
              height="850"
              v-show="loadingStatus"
              :loading="loadingStatus"
              class="mb-3 mt-4"
              type="list-item-avatar-two-line,table@2"
              elevation="2"
            >
            </v-skeleton-loader>
            <nba-top-plays-table
              v-show="!loadingStatus"
              :playerDetails="this.playersDetail"
              :selectionD="selectionD"
              :selectionDS="selectionDS"
              :selectionF="selectionF"
              :selectionFS="selectionFS"
              :slates="Slates"
              :slateID="slateId"
              :defaultSport="defaultSport"
              :defaultOptimizer="defaultOptimizer"
            />
          </v-col>
        </v-row>
      </v-col>
      <!--//? Position optimizer table -->

      <!--//* build team table -->
      <v-col cols="12" md="5" sm="12">
        <!-- banner -->
        <v-banner v-once color="#00838F" rounded class="Info-banner mx-1">
          <p class="body-1">
            Instructions <v-icon>mdi-newspaper-variant-outline</v-icon>&nbsp;
          </p>
          <ol class="text-body-2 white--text mt-n2">
            <li>
              Make changes to the Optimizer (lock, exclude, team stacks, etc).
            </li>
            <li>
              Click the checkbox on each players row to save it in your lineup.
            </li>
            <li>To remove the player from lineup uncheck the checkbox.</li>
          </ol>
        </v-banner>
        <v-skeleton-loader
          height="950"
          v-show="topPlayersLoader"
          :loading="topPlayersLoader"
          class="mt-3 mx-2"
          type="list-item-avatar-two-line,table@2"
          elevation="2"
        >
        </v-skeleton-loader>
        <save-top-plays-table
          v-show="!topPlayersLoader"
          :operator="this.operator"
          :operatorGameType="this.operatorGameType"
          :sportType="sportType"
          :sportId="sportId"
          :slates="Slates"
          :slateID="slateId"
          :defaultSport="defaultSport"
          :defaultOptimizer="defaultOptimizer"
          :playerDetails="topPlayers"
        />
      </v-col>
    </v-row>

    <!-- Position optimizer ends -->
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { showPlayers } from "@/mixins/showPlayers.js";

// import NbaTopPlaysTable from '@/components/Tables/TopPlaysTable/NbaTopPlaysTable';
const NbaTopPlaysTable = () =>
  import("@/components/Tables/TopPlaysTable/NbaTopPlaysTable");

// import SaveTopPlaysTable from '../../../components/Tables/TopPlaysTable/saveTopPlaysTable.vue';
const SaveTopPlaysTable = () =>
  import("../../../components/Tables/TopPlaysTable/saveTopPlaysTable.vue");

export default {
  name: "nbaTopPlaysClient",
  props: ["allSlate", "defaultSport", "defaultOptimizer"],
  mixins: [showPlayers],
  components: {
    NbaTopPlaysTable,
    SaveTopPlaysTable,
  },

  data() {
    return {
      radio: "others",
      Slates: [],
      operator: "",
      operatorGameType: "",
      gameName: "",
      slateId: "",
      userId: localStorage.getItem("user"),
      role: localStorage.getItem("role"),
      sportType: "",
      sportId: "",
      positionD: ["PG", "SG", "SF", "PF", "C", "G", "F", "UTIL"],
      positionF: ["PG", "SG", "SF", "PF", "C"],
      positionFS: ["MVP", "STAR", "PRO", "UTIL", "UTIL2"],
      positionDS: ["CPT", "UTIL"],
      selectionD: "UTIL",
      selectionDS: "CPT",
      selectionF: "PG",
      selectionFS: "MVP",
    };
  },

  computed: {
    ...mapGetters("NbaModule", [
      "loadingStatus",
      "getFilterByPosition",
      "getFilterBySingle",
      "getFilterByPositionInFanduel",
      "topPlayersLoader",
    ]),
    ...mapState("NbaModule", ["playersDetail", "topPlayers"]),
  },
};
</script>

<style scoped>
.chip-selector >>> .v-chip.v-size--default {
  border-radius: 8px;
}
</style>
